import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat)

@Injectable()

export class InputDateAdapter extends NativeDateAdapter {

    format(date: Date, displayFormat: Object): string {
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
    }

    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    }


    parse(value: any): Date | null {

        if ((typeof value === 'string') && (value as string).length > 0) {

            const formats = [
                "DD/MM/YYYY",
                "D/M/YYYY",
                "DD/MM/YY",
                "D/M/YY",
                "DD-MM-YYYY",
                "D-M-YYYY",
                "DD-MM-YY",
                "D-M-YY",
                "DDMMYYYY",
                "DMYYYY",
                "DDMMYY",
                "DMYY",
            ];

            var date = dayjs(value, formats, 'es', true);

            return date.toDate();
        }

        return null;
    }


}
